import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import {
    TradingProcedureOrganizationTypePermissionResponseDto
} from '../schemas/trading-procedure-organization-type-permission-response.dto';
import {
    CreateTradingProcedureOrganizationTypePermissionRequestDto
} from '../schemas/create-trading-procedure-organization-type-permission-request.dto';

@Injectable({ providedIn: 'root' })
export class TradingProcedureOrganizationTypePermissionAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/tradingProcedureOrganizationTypePermissionAdmin`;

    getAll(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<TradingProcedureOrganizationTypePermissionResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<TradingProcedureOrganizationTypePermissionResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }

    create(payload: CreateTradingProcedureOrganizationTypePermissionRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/create`)
            .post(payload)
            .json<TradingProcedureOrganizationTypePermissionResponseDto>()
            .build()
            .send();
    }

    delete(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/delete`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
